import { render } from "./CompanyRecords.vue?vue&type=template&id=1f3d3380&scoped=true"
import script from "./CompanyRecords.vue?vue&type=script&lang=js"
export * from "./CompanyRecords.vue?vue&type=script&lang=js"

import "./CompanyRecords.vue?vue&type=style&index=0&id=1f3d3380&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f3d3380"]])

export default __exports__